<template>
  <div class="accordion">
    <div
      v-for="(item, index) in items"
      :key="items[`${itemId}`] || index"
      class="card"
    >
      <div
        id=""
        class="card-header"
        @click="activateAnswer(index)"
      >
        <div class="mb-0">
          {{ item[`${itemTitle}`] }}
        </div>
      </div>
      <transition name="collapse">
        <div
          class="collapse"
          :class="{
            show: index === activeItemIndex
          }"
        >
          <div
            class="card-body"
            v-html="item[`${itemContent}`]"
          />
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BootstrapAccordion',
  props: {
    items: {
      type: Array,
      required: true
    },
    itemTitle: {
      type: String,
      default: 'title'
    },
    itemContent: {
      type: String,
      default: 'content'
    },
    itemId: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      activeItemIndex: 0
    }
  },
  methods: {
    activateAnswer (index) {
      this.activeItemIndex = index
    }
  }

}
</script>
